import { useQuery } from 'react-query';
import {
  ADDRESS_COORDINATES_AUTOCOMPLETE_QUERY_KEY,
  queryAddressCoordinatesAutocomplete,
} from './useAddressCoordinatesAutocomplete.query';
import { UseAddressCoordinatesAutocompleteQueryParams } from './useAddressCoordinatesAutocomplete.types';
import { AddressCoordinatesFeature } from '../../../types/models/address/address.types';

export const useAddressCoordinatesAutocomplete = (
  address: string,
  params?: UseAddressCoordinatesAutocompleteQueryParams
) => {

  const enabled = params?.enabled === undefined ? true : false

  return (
    useQuery<AddressCoordinatesFeature[], Error>(
      [ADDRESS_COORDINATES_AUTOCOMPLETE_QUERY_KEY, address],
      () => queryAddressCoordinatesAutocomplete(address, params),
      {
        retry: false,
        refetchOnWindowFocus: false,
        enabled: Boolean(enabled)
      }
    )
  )
}
